import React from 'react';
import config from '../../../config';
import './app_display_name.scss';

export default function AppDisplayName() {
  return (
    <div className="app-display-name">
      {config.APP_DISPLAY_NAME}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/app_footer/app_display_name/app_display_name.jsx